import React from "react";
import { Route, useLocation } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { createGlobalStyle } from "styled-components";
import { darken } from "polished";
import parse from "url-parse";
import { createImageCdnLink, handleError } from "@low6dev/react-utils/dist";
import { useTranslations } from "hooks";
import Topbar from "./layout/topbarNew/Topbar";
import Navbar from "./layout/navbar/Wrapper";
// import Bottombar from "./layout/bottombar/Bottombar";
// import BottombarIcon from "./layout/bottombar/BottombarIcon";
import Content from "./layout/content/Content";
import { Drawer as AppDrawer } from "@low6dev/low6-private/dist";
// import Toolbar from "components/layout/toolbar/Toolbar";
import Betbar from "components/feature/betbar/Wrapper";

import { clearDrawer, openDrawer } from "components/feature/drawer/actions";

import { LegalFooter as AppLegalFooter } from "fiver-react-ui-components";

import { Overlay, Low6Footer } from "fiver-react-ui-components";

import { setAuth } from "components/feature/auth/actions";

import { MissingDataPopup } from "@low6dev/react-feature-auth/dist";
// import { setToolbar } from "components/layout/toolbar/actions";

const ToastStylesForBottomBarPages = createGlobalStyle`
  body .Toastify__toast-container--bottom-center {
    bottom: 0;
    z-index: 6;
  }
`;

const ToastStylesForBottomBarWithIcon = createGlobalStyle`
  body .Toastify__toast-container--bottom-center {
    bottom: 0;
    z-index: 6;
  }

  body .Toastify__toast {
    margin-bottom: 0;
    min-height: 98px;
    font-size: 1.25rem;
  }
`;

const BodyBackgroundColorPrimary = createGlobalStyle`
body {
  background: ${(props) =>
    props.hasPrimaryBackground
      ? props.theme.colorPrimary
      : process.env.REACT_APP_BACKGROUND_IMAGE
        ? `${darken(0.2, props.theme.colorPrimary)} url(${createImageCdnLink(
          process.env.REACT_APP_BACKGROUND_IMAGE
        )})`
        : props.theme.colorLightGrey};


  @media (min-width: ${(props) => props.theme.screenWidthMd}) {
    background: ${(props) => props.theme.colorBackground};
  }
}
`;

const heightToAppear = 1;

const AppRoute = ({
  path,
  exact,
  isLandingPage,
  isLeaderboard,
  hideLow6Footer,
  hideTopbar,
  hideLegalFooter,
  needsPaddingTop,
  component,
  noPadding,
  hasPrimaryBackground,
  hasToolbar,
  topbarTitleLogo,
  topbarTitle,
  topbarBackButton,
  topbarBackButtonText,
  topbarBurgerMenu,
  buttonWidth,
  bottombar,
  betbarParent = {},
  onClearButtonClicked,
  onPicksCleared,
  isClearingPicks,
  setBetbarParent,
  picksData,
  setPicksData,
  getPage,
  style,
  machData,
}) => {
  const dispatch = useDispatch();

  const [translations] = useTranslations();

  const { isAuthChecked } = useSelector((s) => s.auth);

  const { isOpen, useAssetsCdn, pageSlug, pageTitle } = useSelector(
    (s) => s.drawer
  );

  const location = useLocation();

  const url = parse(location?.search, true);
  const isFromSignupPage = url.query.signup === "true";

  const xtremePushId = url.query.xtreme_push_id;
  // console.log(device_id, 'IDS');
  const app = useSelector((s) => s.app);
  const { isBetsOpen, language } = app;
  const { activePickemList } = betbarParent;

  const handlePageButtonClicked = (pageSlug, pageTitle) => {
    dispatch(openDrawer(pageSlug, pageTitle));
  };

  const handlePageButtonClickedFooter = () => {
    const pageUrl =
      language === "en" ? "game-rules-toto-english" : "game-rules-toto-dutch";
    dispatch(openDrawer(pageUrl, translations.rules, false));
  };

  return (
    <Route path={path} exact={exact}>
      <MissingDataPopup
        setAuth={setAuth}
        dateFormat={process.env.REACT_APP_DATE_FORMAT}
        appearOnUsersCreatedBefore={process.env.REACT_APP_CREATION_DATE}
      />
      <BodyBackgroundColorPrimary hasPrimaryBackground={hasPrimaryBackground} />
      {!hideTopbar && process.env.REACT_APP_HIDE_TOPBAR !== "true"
        ? React.createElement(Topbar, {
          topbarTitle,
          topbarBackButton: isFromSignupPage ? false : topbarBackButton,
          topbarBackButtonText,
          topbarBurgerMenu,
          topbarTitleLogo,
          buttonWidth,
        })
        : null}
      {hasToolbar && (
        <>
          <Overlay
            zIndex={3}
          // onClick={handleOverlayClicked}
          // isVisible={isBetsOpen || shouldShowOverlayForBetbar}
          />
          {/* {isAuthChecked && ( */}
          <Betbar
            hideHelp={process.env.REACT_APP_BETBAR_HIDE_HELP !== "true"}
            onHelpButtonClicked={() =>
              handlePageButtonClicked(
                process.env.REACT_APP_SLUG_TERMS,
                translations.termsConditions
              )
            }
            brandingImageUrl={
              process.env.REACT_APP_BRANDING_LOGO &&
              createImageCdnLink(process.env.REACT_APP_BRANDING_LOGO)
            }
            // onHelpButtonClicked={() => console.log("onHelpButtonClicked")}
            onClearButtonClicked={onClearButtonClicked}
            app={app}
            betbarParent={betbarParent}
            setBetbarParent={setBetbarParent}
            picksData={picksData}
            setPicksData={setPicksData}
            isLeaderboard={isLeaderboard}
          />
          {/* )} */}
        </>
      )}
      {bottombar && (
        <>
          <ToastStylesForBottomBarPages />
          <Navbar />
        </>
      )}
      {/* {bottombar && (
        <>
          {process.env.REACT_APP_NAV_ICON && (
            <>
              <ToastStylesForBottomBarWithIcon />
              <BottombarIcon />
            </>
          )}
          {!process.env.REACT_APP_NAV_ICON && (
            <>
              <ToastStylesForBottomBarPages />
              <Bottombar />
            </>
          )}
        </>
      )} */}
      <Content
        isLeaderboard={isLeaderboard}
        needsPaddingTop={needsPaddingTop}
        noPadding={noPadding}
        hasPrimaryBackground={hasPrimaryBackground}
        style={style}
      >
        {React.createElement(component, {
          betbarParent,
          setBetbarParent,
          picksData,
          setPicksData,
          isClearingPicks,
          onPicksCleared,
        })}

        {!hideLegalFooter && (
          <AppLegalFooter
            getPage={handlePageButtonClicked}
            appTitle={process.env.REACT_APP_TITLE}
            hideGamblingReferences
            hidePrivacyPolicy
            hideLow6Help
            hideContactSupport
            termsConditionsFilename={process.env.REACT_APP_SLUG_TERMS}
            translations={translations}
          />
        )}
        {process.env.REACT_APP_SHOW_LOW6_FOOTER === "true" && (
          <Low6Footer
            onError={handleError}
            getPage={handlePageButtonClickedFooter}
            appVersion="1.0.0"
            appTitle={process.env.REACT_APP_TITLE}
            appIconUrl={createImageCdnLink(process.env.REACT_APP_MAIN_ICON)}
            translations={translations}
            hideGamblingReferences
            hideCtaButton
            hasRoundedRulesButton
            hasDutchCompliance
            dutchComplianceText={translations.dutchComplianceText}
            eighteenPlusIcon="https://cdn.jsdelivr.net/gh/low6dev/fiver-react-assets/18Plus-Icon.png"
          />
        )}

      </Content>
      <AppDrawer
        isOpen={isOpen}
        useAssetsCdn={useAssetsCdn}
        pageSlug={pageSlug}
        pageTitle={pageTitle}
        onDrawerClosed={() => dispatch(clearDrawer())}
        onError={handleError}
      />
    </Route>
  );
};

export default AppRoute;
